/* import __COLOCATED_TEMPLATE__ from './identity.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { TextField } from 'field-kit';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import assert from '@banking/ui/utils/assert';
import USDateFormatter from '@banking/ui/utils/field-kit-formatters/us-date-formatter';
import { DATE_OF_BIRTH_FIELD_IDENTIFIER } from '@banking/ui/models/checking/onboarding/identity';
import { FieldIdentifier as AddressFieldIdentifier } from '@banking/ui/models/common/address';
import { inject as service } from '@ember/service';
let Identity = (_class = class Identity extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "DATE_OF_BIRTH_FIELD_IDENTIFIER", DATE_OF_BIRTH_FIELD_IDENTIFIER);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  get buttons() {
    return [{
      rank: 'primary',
      disabled: this.args.nextButtonDisabled,
      text: this.intl.t('banking.checking.onboarding.identity.nextButtonCTA'),
      onClick: this.args.onNextButtonClick
    }];
  }
  _onAddressValueChange(fieldCandidate, valueCandidate) {
    assert(fieldCandidate != null && typeof fieldCandidate === 'string' && fieldCandidate in AddressFieldIdentifier);
    // FIXME(steckel): Find a way to type-narrow over type-casting
    const field = fieldCandidate;
    assert(typeof valueCandidate === 'string');
    // FIXME(steckel): Find a way to type-narrow over type-casting
    const value = valueCandidate;
    this.args.onValueChange({
      field,
      value
    });
  }
  async initializeFieldKit(marketInputTextElement) {
    const inputElement = await marketInputTextElement.getInputElement();
    const formatter = new USDateFormatter();
    if (this.args.initialDateOfBirth) {
      // eslint-disable-next-line require-atomic-updates
      marketInputTextElement.value = formatter.format(this.args.initialDateOfBirth);
    }
    const fieldKit = new TextField(inputElement, formatter);
    const textDidChange = field => {
      const value = field.value();
      this.args.onValueChange({
        field: DATE_OF_BIRTH_FIELD_IDENTIFIER,
        value
      });
    };
    fieldKit.setDelegate({
      textDidChange
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_onAddressValueChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_onAddressValueChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initializeFieldKit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFieldKit"), _class.prototype), _class);
export { Identity as default };